import "./Stepper.scss";
import moment from "moment";
import { useLanguage } from "../../context/LanguageContext";

export const Stepper = ({ statusArray = [] }) => {
  const { t, language, dir } = useLanguage();

  // Define the order of statuses for the stepper
  const statusOrder = [
    "booked",
    "onTheWay",
    "technicianArrived",
    "inProgress",
    "completed",
  ];

  // Format date function using moment
  const formatDate = (dateString) => {
    try {
      // Use the current language for formatting
      return moment(dateString).locale(language).format("DD/MM/YYYY - hh:mm A");
    } catch (error) {
      console.error("Error formatting date:", error);
      return "Invalid Date";
    }
  };

  // Find the current step based on the most recent status
  const getCurrentStep = () => {
    // If no status is available, return 0
    if (statusArray.length === 0) return 0;

    // If order is canceled, return special case
    const isCanceled = statusArray.some(
      (status) => status.value === "canceled"
    );
    if (isCanceled) return -1;

    // Find the most recent status in the status order
    let highestStep = 0;
    statusArray.forEach((status) => {
      const stepIndex = statusOrder.indexOf(status.value);
      if (stepIndex > -1 && stepIndex + 1 > highestStep) {
        highestStep = stepIndex + 1;
      }
    });

    return highestStep;
  };

  // Get status date if available
  const getStatusDate = (statusValue) => {
    const statusItem = statusArray.find((item) => item.value === statusValue);
    return statusItem ? formatDate(statusItem.date) : "";
  };

  // Calculate current step
  const currentStep = getCurrentStep();

  // Check if order is canceled
  const isCanceled = currentStep === -1;

  return (
    <div className={`stepper ${dir === "rtl" ? "rtl" : "ltr"}`}>
      <p className="title">{t("stepper.orderStatus")}</p>
      {isCanceled ? (
        <div className="canceled-status">
          <p className="statue">{t("stepper.statuses.canceled")}</p>
          <p className="date">{getStatusDate("canceled")}</p>
        </div>
      ) : (
        <div className="steps">
          {statusOrder.map((status, index) => (
            <div
              key={status}
              className={`step ${currentStep >= index + 1 ? "active" : ""}`}
            >
              <p className="circle"></p>
              <div className="content">
                <p className="statue">{t(`stepper.statuses.${status}`)}</p>
                <p className="date">{getStatusDate(status)}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Stepper;
